export default __webpack_public_path__ + "static/media/accounting_point_3.63427bb8.png";